import React from 'react';

import styles from './Header.module.css';
import { ReactComponent as Logo } from '../../assets/logo.svg';

interface HeaderProps { }

const Header = (props: HeaderProps) => {
  return (
    <header className={styles.header}>
      <p className={styles.title}>My balance</p>
      <p className={styles.value}>$921.48</p>
      <div className={styles.logo}>
        <Logo/>
      </div>
    </header>
  );
};

export default Header;
